import type { SVGProps } from 'react';

const SvgNode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 8c-.74 0-1.43.21-2.02.57L7.82 6.41c.11-.28.18-.59.18-.91a2.5 2.5 0 0 0-5 0A2.5 2.5 0 0 0 5.5 8c.32 0 .63-.07.91-.18l2.16 2.16C8.22 10.57 8 11.26 8 12c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4"
    />
  </svg>
);
export default SvgNode;
